module.exports = __webpack_public_path__ + "img/icon_selfactualization_white.996a6b35.svg";